import { render, staticRenderFns } from "./customerPriceListPreviewDialog.vue?vue&type=template&id=2a09598f&"
import script from "./customerPriceListPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./customerPriceListPreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports